__turbopack_context__.v({
  "className": "wZIuDa_className",
});
